import { apiSlice } from "app/api/apiSlice";

//
//
interface bannerList {
    id: number,
    banner_name: string,
    background_image: string,
    background_url: string,
    background_colour?: string,
    image_text?: string,
    image?: string,
    image_url?: string,
    banner_link?: string,
    order?: string
}
//
//
//
export const bannerListApi = apiSlice.injectEndpoints({

    endpoints: (builder) => ({
        getBannerList: builder.query<any, void>({
            query: () => "/showroom/api/v1/homebanner/list",
            keepUnusedDataFor: 900,
            transformResponse: (response: { data: bannerList[] }) => {
                return response.data
            },
        })
    }),
});

//
export const { useGetBannerListQuery } = bannerListApi; 
